module.exports = __webpack_public_path__ + "static/images/light-bg.9a430ef.png";